import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./button.module.css";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const Button = (props) => {
  return (
    <button
      name={props.name}
      className={`${styles.button_container} ${
        props?.type ? styles[props.type] : ""
      }`}
      style={props?.style}
      onClick={(event) => {
        props?.clickHandler(event);
      }}
    >
      {props?.isIcon && (
        <FontAwesomeIcon icon={faPlus} style={{ paddingRight: "5px" }} />
      )}
      {props.text}
    </button>
  );
};

export default Button;
